import { render } from "./sendCourse.vue?vue&type=template&id=0822b94e"
import script from "./sendCourse.vue?vue&type=script&lang=js"
export * from "./sendCourse.vue?vue&type=script&lang=js"

import "./sendCourse.vue?vue&type=style&index=0&id=0822b94e&lang=css"

import exportComponent from "C:\\ProgramData\\Jenkins\\.jenkins\\workspace\\四个火体育_web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__